import CloudUtils from '../../utils/CloudUtils'
import EnvUtils from '../../utils/EnvUtils'
import Tools from '../../utils/Tools'

class AppErrorService {
  async save (message, stack) {
    const platform = EnvUtils.inLight() ? 3 : Tools.verfyBrowserType() ? 2 : 1
    var result = null;
    try {
      result = await CloudUtils.post('/shuimujiaju-customer-api/app/error/save', {
        platform,
        message,
        stack,
      })
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new AppErrorService()
